import React from "react";
import { format } from "date-fns";

const DisplayCreatedFields = ({ data }) => {
  const formatLocalTime = (dateString) => {
    return format(new Date(dateString), "dd/MM/yyyy HH:mm:ss");
  };

  return (
    <div className="text-gray-400 text-sm">
      {data.createdBy && (
        <>
          <span className="font-semibold">Created By:</span>{" "}
          {data.createdBy.firstName} {data.createdBy.lastName}
          <br />
        </>
      )}
      {data.createdAt && (
        <>
          <span className="font-semibold">Created At:</span>{" "}
          {formatLocalTime(data.createdAt)}
          <br />
        </>
      )}
      {data.lastEditedBy && (
        <>
          <span className="font-semibold">Last Edited By:</span>{" "}
          {data.lastEditedBy.firstName} {data.lastEditedBy.lastName}
          <br />
        </>
      )}
      {data.lastEditedAt && (
        <>
          <span className="font-semibold">Last Edited At:</span>{" "}
          {formatLocalTime(data.lastEditedAt)}
          <br />
        </>
      )}
    </div>
  );
};

export default DisplayCreatedFields;
